export class LCUElementContext<TState> {
  public State?: TState;
}
